import gql from 'graphql-tag'

export const AcknowledgePopup = gql`
  mutation ($shipToIds: [String!]!) {
    acknowledgeDeliveryExceptionPopup(shipToIds: $shipToIds)
  }
`
